import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { BaseNotyClass, NotyData, StickyNotySize } from './noty.interface';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'dn-noty',
  templateUrl: './dn-noty.component.html',
  styleUrl: './dn-noty.component.scss',
  standalone: false,
})
export class DnNotyComponent implements OnInit {
  @Input() bodyText: string;
  @Input() ctaText: string;
  @Input() ctaClick: () => any;
  @Input() showCta = false;
  @Input() showCloseBtn = false;
  @Input() icon: string;
  @Input() containerClass: BaseNotyClass;
  @Input() size: StickyNotySize = StickyNotySize.Normal;
  // tslint:disable-next-line:no-output-on-prefix
  @Output() onDismiss: EventEmitter<any> = new EventEmitter<any>();
  snackData: NotyData;
  private readonly snackRef: MatSnackBarRef<DnNotyComponent> = null;
  constructor(private readonly injector: Injector) {
    this.snackRef = this.injector.get(MatSnackBarRef, null);
    this.snackData = this.injector.get(MAT_SNACK_BAR_DATA, null);
  }
  ngOnInit(): void {
    if (this.snackData) {
      this.bodyText = this.snackData.bodyText;
      this.showCta = this.snackData.showCta;
      this.ctaText = this.snackData.ctaText;
      this.ctaClick = this.snackData.ctaClick;
      this.containerClass = this.snackData.containerClass;
      this.icon = this.snackData.icon;
      this.showCloseBtn = true;
    }
  }

  onClick(): void {
    this.ctaClick();
  }

  get _icon(): string {
    if (this.icon) {
      return `${environment.icons_url}/${this.icon}.svg`;
    }
  }

  close(): void {
    this.onDismiss.emit();
    if (this.snackData) {
      this.snackRef.dismiss();
    }
  }
}
